export default __webpack_public_path__ + "static/media/device-pile.8e6539e8.png";